import PositionBriefCardComponent from './PositionBriefCard.component';
import PositionBriefCardLoader from './PositionBriefCardLoader';

const PositionBriefCard = Object.assign(PositionBriefCardComponent, {
  Loading: PositionBriefCardLoader,
});

export default PositionBriefCard;
